import { operators as o } from '@pendo/aggregations';
import { getPipelineProps, compile } from '@/segments/segment';

export default class SegmentCardHelper {
    static buildAudiencePipeline (filters, advancedOptions) {
        return Promise.resolve(compile(filters, advancedOptions));
    }

    static async buildCustomAudiencePipeline (segment, { showGuidesToAnon, isReplayCaptureSegment = false } = {}) {
        const segmentPipeline = await getPipelineProps(segment);

        return o.pipeline(
            o.sources.visitors({ identified: !showGuidesToAnon && !isReplayCaptureSegment, blacklist: 'ignore' }),
            o.evaluate('accountId', 'metadata.auto.accountids'),
            o.unwind('accountId', { keepEmpty: true }),
            o.segment(segmentPipeline),
            o.select({ visitorId: 'visitorId' }),
            o.group(['visitorId']),
        );
    }
}
